var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', {
    attrs: {
      "items": _vm.operators,
      "item-text": "label",
      "item-value": "value",
      "label": "Operator",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.localValue,
      callback: function callback($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }